<template>
  <div>
    <DialogViewTask
      v-if="isOpenViewTask"
      v-model="isOpenViewTask"
      :task-id="selectedTaskId"
      @task-updated="handleTaskUpdated"
    />

    <CardLayout v-if="tasks.length > 0" title="Task History">
      <v-row class="cursor-pointer">
        <v-col
          v-for="task in tasks"
          :key="task.id"
          class="col-sm-12 col-md-6 col-lg-3"
          @click="openTaskDialog(task)"
        >
          <CardLayout :title="task.title">
            <dl class="property-list my-4">
              <dt>Task ID</dt>
              <dd>{{ task.taskId }}</dd>
              <dt>Priority</dt>
              <dd>
                <SeverityChip :severity="titleCase(task.priority)" />
              </dd>
              <dt>Assignee</dt>
              <dd>
                {{ task.assignee.firstName }} {{ task.assignee.lastName }}
              </dd>
              <dt>Due Date</dt>
              <dd>{{ facilityFormatDateTime4Humans(task.dueAt) }}</dd>
            </dl>
          </CardLayout>
        </v-col>
      </v-row>
    </CardLayout>
  </div>
</template>

<script>
import CardLayout from "@layout/CardLayout.vue";
import { ref, computed, watch } from "vue";
import useIncident from "@components/incident/useIncident";
import { formatIncidentType } from "@components/common/helpers/incident";
import { formatPhoneNumber } from "@tod-ui/helpers/phone";
import SeverityChip from "@tod-ui/components/SeverityChip.vue";
import DialogViewTask from "../manage_tasks/DialogViewTask.vue";
import { titleCase } from "@tod-ui/helpers/strings";

export default {
  name: "CardIncidentTasks",
  components: {
    CardLayout,
    SeverityChip,
    DialogViewTask,
  },
  props: {
    incident: {
      type: Object,
      default: null,
    },
    isAssignToManager: {
      type: Boolean,
      default: false,
    },
    singleColumn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isOpenViewTask = ref(false);
    const selectedTaskId = ref({});

    const { incident, fetchIncident, loading } = useIncident();

    // watch(
    //   () => props.incident,
    //   (newIncident) => {
    //     if (newIncident && newIncident.id) {
    //       fetchIncident(newIncident.id);
    //     }
    //   },
    //   { immediate: false }
    // );

    const tasks = computed(() => {
      if (props.incident) {
        return props.incident.tasks || [];
      } else {
        return incident.value ? incident.value.tasks : [];
      }
    });

    return {
      isOpenViewTask,
      selectedTaskId,
      fetchIncident,
      tasks,
      loading,
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },

    openTaskDialog(task) {
      this.selectedTaskId = task.id;
      this.isOpenViewTask = true;
    },
    facilityFormatDateTime4Humans(dateTime) {
      if (!dateTime) return "N/A";
      return new Date(dateTime).toLocaleString();
    },

    formatResponder(responder) {
      if (!responder) return "--";
      if (!responder.contactMethod?.value) return responder.name;
      return `${responder.name} @ ${formatPhoneNumber(
        responder.contactMethod.value
      )}`;
    },
    handleTaskUpdated() {
      this.isOpenViewTask = false;
      if (this.incident.id) {
        this.fetchIncident(this.incident.id);
      }
    },
    formatIncidentType,
    titleCase,
  },
};
</script>

<style lang="scss" scoped>
.property-list {
  dd {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &.two-columns {
    grid-template-columns: repeat(2, max-content auto);
  }
}

.cursor-pointer {
  cursor: pointer;
}

.card-incident-tasks {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  margin-top: 4px;
  width: 100%;
  box-sizing: border-box;
}

.task-list {
  max-height: 300px; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  padding-right: 10px; /* Add some padding for the scrollbar */
}

.task-item {
  margin-bottom: 8px;
  padding: 8px;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: column;
}

.task-item:last-child {
  border-bottom: none;
}

.task-label {
  font-weight: bold;
  margin-right: 0;
  margin-bottom: 4px;
}

.task-value {
  word-wrap: break-word;
}

/* Add hand cursor on hover */
.task-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

@media (max-width: 600px) {
  .card-incident-tasks {
    padding: 8px;
  }

  .task-item {
    padding: 6px;
  }
}
</style>
